module.exports = __webpack_public_path__ + "static/media/Guide_Conecta_Tracking.d9e0eeee.pdf";